import { useEffect, useState } from "react";
import {
	UserIcon,
	UserGroupIcon,
	BuildingOfficeIcon,
	ChevronRightIcon,
	ClockIcon,
	CheckBadgeIcon,
	MapPinIcon,
	ShieldCheckIcon as ShieldCheckIconOutline,
	HeartIcon as HeartIconOutline,
	SparklesIcon as SparklesIconOutline,
	UserCircleIcon as UserCircleIconOutline,
	HandRaisedIcon as HandRaisedIconOutline,
	Bars3Icon,
	XMarkIcon,
} from "@heroicons/react/24/outline";

import logo from '../Signup/img/logo.svg'
import '../Signup/landing.scss'
import { Link } from "react-router-dom";
// import '../Signup/tailwind.scss'


const AboutUs = () => {
	useEffect(() => {
		document.body.classList.add("tailwind-body");

		return () => {
			document.body.classList.remove("tailwind-body");
		};
	}, []);

	const [showStickyHeader, setShowStickyHeader] = useState(false);
	const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
	const [isAuthenticated, setIsAuthenticated] = useState(false);

	useEffect(() => {
		const token = localStorage.getItem('token');
		setIsAuthenticated(!!token);
	}, []);

	useEffect(() => {
		const handleScroll = () => {
			const scrollPosition = window.scrollY;
			setShowStickyHeader(scrollPosition > 200);
		};

		window.addEventListener("scroll", handleScroll);
		return () => window.removeEventListener("scroll", handleScroll);
	}, []);
	return (
		<div className="about">
			<div className="min-h-screen bg-gradient-to-b from-sky-50 via-white to-sky-50 rounded-3xl md:m-5">
				<div
					className={`fixed inset-x-0 top-4 z-50 flex justify-center transition-all duration-300 ${showStickyHeader
						? "translate-y-0 opacity-100"
						: "-translate-y-full opacity-0"
						}`}
				>
					<nav className="w-full max-w-[600px] mx-4 flex items-center justify-between rounded-full bg-white/80 backdrop-blur-md shadow-md shadow-sky-900/5 ring-1 ring-slate-200 px-5 py-4">
						<Link to='/' className="flex items-center space-x-2">
							<img src={logo} alt="Emissary Care" className="h-8 w-auto" />
						</Link>
						{/* Desktop Navigation */}
						<div className="hidden md:flex items-center gap-x-8">
							<Link
								to='/'
								className="text-sm font-semibold leading-6 text-slate-900 hover:text-blue-600 transition-colors duration-200"
							>
								About Us
							</Link>
							<Link
								to="/about/how"
								className="text-sm font-semibold leading-6 text-slate-900 hover:text-blue-600 transition-colors duration-200"
							>
								How It Works
							</Link>
							<div className="flex items-center gap-x-4 pl-8 border-l border-gray-200">
								{isAuthenticated ? (
									<Link
										to="/profile"
										className="inline-flex items-center gap-2 text-sm font-semibold leading-6 text-slate-900 hover:text-blue-600 transition-colors duration-200"
									>
										<UserIcon className="h-5 w-5" />
										My Profile
									</Link>
								) : (
									<>
										<Link
											to="/auth/login"
											className="text-sm font-semibold leading-6 text-slate-500 hover:text-blue-600 transition-colors duration-200"
										>
											Log in
										</Link>
										<Link
											to="/"
											className="group relative rounded-full px-5 py-2 text-sm font-semibold"
										>
											<span className="absolute inset-0 rounded-full bg-blue-500 transition-all duration-200 ease-in-out group-hover:bg-blue-600"></span>
											<span className="absolute inset-0 rounded-full ring-2 ring-blue-400/40 transition-all duration-200 ease-in-out group-hover:ring-blue-500/40"></span>
											<span className="relative text-white">Sign up</span>
										</Link>
									</>
								)}
							</div>
						</div>
						{/* Mobile Menu Button */}
						<button
							type="button"
							className="md:hidden inline-flex items-center justify-center rounded-full bg-slate-50/50 text-slate-400 hover:text-blue-600 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-blue-500"
							onClick={() => setIsMobileMenuOpen(true)}
						>
							<span className="sr-only">Open main menu</span>
							<Bars3Icon className="h-6 w-6" aria-hidden="true" />
						</button>
					</nav>

					{/* Mobile menu overlay */}
					<div
						className={`fixed inset-0 z-50 transition-opacity duration-300 ${isMobileMenuOpen ? "opacity-100" : "opacity-0 pointer-events-none"
							}`}
					>
						<div
							className="fixed inset-0 bg-slate-900/20 backdrop-blur-sm"
							aria-hidden="true"
							onClick={() => setIsMobileMenuOpen(false)}
						/>
						<div
							className={`fixed inset-y-0 inset-x-0 bg-white shadow-2xl transition-transform duration-300 ease-in-out ${isMobileMenuOpen ? "translate-x-0" : "translate-x-full"
								}`}
						>
							<div className="flex items-center justify-between px-6 py-4 border-b border-slate-200">
								<Link
									to="/"
									className="flex items-center space-x-2"
									onClick={() => setIsMobileMenuOpen(false)}
								>
									<img
										src={logo}
										alt="Emissary Care"
										className="h-8 w-auto"
									/>
								</Link>
								<button
									type="button"
									className="rounded-full p-2 text-slate-500 hover:text-blue-600 hover:bg-slate-100 transition-all duration-200"
									onClick={() => setIsMobileMenuOpen(false)}
								>
									<span className="sr-only">Close menu</span>
									<XMarkIcon className="h-6 w-6" aria-hidden="true" />
								</button>
							</div>
							<div className="px-6 py-8 space-y-8 bg-white h-[calc(100vh-72px)] overflow-y-auto">
								<div className="space-y-5">
									<Link
										to="/about"
										className="flex items-center gap-x-2 text-base font-medium text-slate-800 hover:text-blue-600 transition-colors duration-200"
										onClick={() => setIsMobileMenuOpen(false)}
									>
										<div className="flex h-8 w-8 items-center justify-center rounded-lg bg-slate-100 ring-1 ring-slate-200">
											<UserGroupIcon className="h-5 w-5 text-slate-600" />
										</div>
										About Us
									</Link>
									<Link
										to="/about/how"
										className="flex items-center gap-x-2 text-base font-medium text-slate-800 hover:text-blue-600 transition-colors duration-200"
										onClick={() => setIsMobileMenuOpen(false)}
									>
										<div className="flex h-8 w-8 items-center justify-center rounded-lg bg-slate-100 ring-1 ring-slate-200">
											<SparklesIconOutline className="h-5 w-5 text-slate-600" />
										</div>
										How It Works
									</Link>
								</div>
								<div className="space-y-5 pt-6 border-t border-slate-200">
									{isAuthenticated ? (
										<Link
											to="/profile"
											className="flex items-center gap-x-2 text-base font-medium text-slate-800 hover:text-blue-600 transition-colors duration-200"
											onClick={() => setIsMobileMenuOpen(false)}
										>
											<div className="flex h-8 w-8 items-center justify-center rounded-lg bg-slate-100 ring-1 ring-slate-200">
												<UserIcon className="h-5 w-5 text-slate-600" />
											</div>
											My Profile
										</Link>
									) : (
										<>
											<Link
												to="/auth/login"
												className="flex items-center gap-x-2 text-base font-medium text-slate-800 hover:text-blue-600 transition-colors duration-200"
												onClick={() => setIsMobileMenuOpen(false)}
											>
												<div className="flex h-8 w-8 items-center justify-center rounded-lg bg-slate-100 ring-1 ring-slate-200">
													<UserCircleIconOutline className="h-5 w-5 text-slate-600" />
												</div>
												Log in
											</Link>
											<Link
												to="/signup"
												className="flex items-center justify-between w-full rounded-xl bg-blue-500 px-6 py-3 text-base font-semibold text-white shadow-sm hover:bg-blue-600 transition-colors duration-200 group"
												onClick={() => setIsMobileMenuOpen(false)}
											>
												Sign up
												<SparklesIconOutline className="h-5 w-5 transition-transform duration-200 group-hover:translate-x-0.5" />
											</Link>
										</>
									)}
								</div>
								<div className="pt-6 border-t border-slate-200">
									<div className="rounded-xl bg-slate-50 p-4 ring-1 ring-slate-200">
										<p className="text-sm text-slate-600">
											Now serving Massachusetts, New Hampshire, and Florida
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<header className="relative z-40">
					<nav
						className="mx-auto flex max-w-7xl items-center justify-between p-6 lg:px-8"
						aria-label="Global"
					>
						<div className="flex lg:flex-1">
							<Link to="/" className="flex items-center space-x-2">
								<img
									src={logo}
									alt="Emissary Care"
									className="h-10 w-auto"
								/>
							</Link>
						</div>
						<div className="hidden lg:flex lg:flex-1 lg:justify-center">
							<div className="flex gap-x-12">
								<Link
									to="/about"
									className="text-sm  font-medium leading-6 text-slate-600 hover:text-blue-600 transition-colors duration-200"
								>
									About Us
								</Link>
								<Link
									to="/about/how"
									className="text-sm font-medium leading-6 text-slate-600 hover:text-blue-600 transition-colors duration-200"
								>
									How It Works
								</Link>
							</div>
						</div>
						<div className="flex lg:flex-1 lg:justify-end">
							<div className="flex items-center gap-x-4">
								{isAuthenticated ? (
									<Link
										to="/profile"
										className="inline-flex items-center gap-2 text-sm font-medium leading-6 text-slate-900 hover:text-blue-600 transition-colors duration-200"
									>
										<UserIcon className="h-5 w-5" />
										My Profile
									</Link>
								) : (
									<>
										<Link
											to="/auth/login"
											className="text-sm font-medium leading-6 text-slate-500 hover:text-blue-600 transition-colors duration-200"
										>
											Log in
										</Link>
										<Link
											to="/signup"
											className="group relative rounded-full px-5 py-2 text-sm font-semibold"
										>
											<span className="absolute inset-0 rounded-full bg-blue-500 transition-all duration-200 ease-in-out group-hover:bg-blue-600"></span>
											<span className="absolute inset-0 rounded-full ring-2 ring-blue-400/40 transition-all duration-200 ease-in-out group-hover:ring-blue-500/40"></span>
											<span className="relative text-white">Sign up</span>
										</Link>
									</>
								)}
							</div>
						</div>
					</nav>
				</header>
				<div className="about px-6 py-12 max-w-4xl mx-auto text-slate-700">
					<h1 className="text-3xl font-bold  mb-6 text-start text-gray-600">About Us</h1>

					<p className="mb-6 text-start">
						<b>Emissary</b> is an online platform for finding respite care. Respite
						care is a type of short-term care that is designed to give a break to
						caregivers who need time to rest, attend to personal business, or take
						care of their own health needs. It can also help prevent caregiver
						burnout and allow caregivers to continue providing high-quality care
						over the long term. Emissary strives to connect individuals and families
						with caregivers who have the necessary cultural competencies and skills
						to provide support that is responsive to their cultural beliefs, values,
						and practices. We aim to help address social determinants of health by
						ensuring access to care that is tailored to specific needs and
						preferences.
					</p>

					<p className="mb-6 text-start">
						Some ways in which we work to create value for customers are:
					</p>

					{[
						{
							number: 1,
							title: "Improving access to care:",
							desc:
								"By providing a platform for individuals and families to connect with caregivers who understand their cultural backgrounds, a caregiver marketplace can help overcome barriers to accessing care that arise from language differences, mistrust of the healthcare system, or lack of familiarity with available resources.",
						},
						{
							number: 2,
							title: "Reducing health disparities:",
							desc:
								"By being responsive to the needs of diverse populations, a caregiver marketplace can help reduce health disparities that are often driven by cultural differences and biases.",
						},
						{
							number: 3,
							title: "Enhancing individual-centered care:",
							desc:
								"By facilitating the matching of customers with caregivers who understand their needs and preferences, a caregiver marketplace can help promote care that is intentional and customized.",
						},
						{
							number: 4,
							title: "Supporting community-based care:",
							desc:
								"By connecting individuals and families with caregivers who are embedded in their communities, we can help support community-based care models that are often more effective at addressing the social determinants of health than traditional medical models.",
						},
					].map((item) => (
						<div
							key={item.number}
							className="bg-blue-50 border mb-5 border-blue-100 rounded-xl p-4 mx-[2px]"
						>
							<div className="text-blue-700 font-semibold text-lg mb-2 flex gap-2 items-center">
								<span className="bg-blue-600 text-white w-6 h-6 rounded-full flex items-center justify-center text-sm font-bold">
									{item.number}
								</span>
								<span>{item.title}</span>
							</div>
							<div className="text-sm text-slate-700 text-start">{item.desc}</div>
						</div>
					))}
				</div>
			</div>
		</div>
	)
};

export default AboutUs;
